import { Routes, Route } from "react-router-dom";
import Login from "./Pages/Users/Login";
import Signup from "./Pages/Users/Signup";
import NotFound from "./Pages/Website/NotFound";
import OurServices from "./Pages/Website/OurServices";
import AdminLayout from "./Pages/Admin/layout";
import Landing from "./Pages/Website/Landing";
import ScrollToTop from "./utils/ScrollToTop";
import AuthContext from "./Context/AuthContext";
import UnAuthorized from "./Pages/Website/UnAuthorized";
import NotReady from "./Pages/Website/NotReady/NotReady";
import WhoIsShadow from "./Pages/Website/WhoIsShadow";
import ContactUs from "./Pages/Website/ContactUs";
import { useEffect } from "react";
import api from "./configs/api";
import FindSpecialist from "./Pages/Website/FindSpecialist";

function App() {

  const setTheme = async () => {
    try {
      await api.get("/theme").then((response) => {
        const theme = response.data;
        if (theme) {
          document.documentElement.style.setProperty(
            "--primary-color",
            theme.primaryColor,
          );
          document.documentElement.style.setProperty(
            "--primary2-color",
            theme.primary2Color,
          );
          document.documentElement.style.setProperty(
            "--secondary-color",
            theme.secondaryColor,
          );
        }
      });
    } catch (error) {
      console.error("set theme error: ", error);
    }
  };

  useEffect(() => {
    setTheme();
  }, []);

  return (
    <>
      <ScrollToTop />
      <AuthContext>
        <Routes>
          <Route path='/admin/*' element={<AdminLayout />} />
          <Route path='/login' element={<Login />} />
          <Route path='/signUp' element={<Signup />} />
          <Route path='*' element={<NotFound />} />
          <Route path='/unauthorized' element={<UnAuthorized />} />
          <Route path='/blank' element={<NotReady />} />
          <Route index path='/our_services' element={<OurServices />} />
          <Route index path='/' element={<Landing />} />
          <Route index path='/find-specialist' element={<FindSpecialist />} />
          <Route index path='/aboutus' element={<WhoIsShadow />} />
          <Route index path='/contact-us' element={<ContactUs />} />
        </Routes>
      </AuthContext>
    </>
  );
}

export default App;
